import React, { useCallback } from "react";
import styled from "styled-components";
import { useCarouselContext } from "../context";
import { AnalyticsEventTypes, sendEvent } from "../../../functional/analyticsUtils";
import { useAnalytics } from "../../../providers/AnalyticsProvider";
const _CarouselTrigger = ({ to, className, children }) => {
    const { state, dispatch } = useCarouselContext("CarouselTrigger");
    const { page, blade, uiLocation } = useAnalytics();
    const getTriggerState = () => {
        switch (to) {
            case "previous":
                return !state?.canScrollPrev;
            case "next":
                return !state?.canScrollNext;
            default:
                return false;
        }
    };
    const triggerToClass = () => {
        switch (to) {
            case "previous":
                return "trigger-previous";
            case "next":
                return "trigger-next";
            default:
                return `trigger-slide-${to}`;
        }
    };
    const trigger = useCallback(() => {
        switch (to) {
            case "next":
                sendEvent(AnalyticsEventTypes.ui_interaction, {
                    uiInteractionType: "carousel_next",
                    page,
                    blade,
                    uiLocation,
                });
                return dispatch({ type: "goToNext" });
            case "previous":
                sendEvent(AnalyticsEventTypes.ui_interaction, {
                    uiInteractionType: "carousel_previous",
                    page,
                    blade,
                    uiLocation,
                });
                return dispatch({ type: "goToPrevious" });
            default:
                return dispatch({ type: "goTo", index: to });
        }
    }, [to, dispatch, page, blade, uiLocation]);
    return (React.createElement("button", { type: "button", tabIndex: -1, "aria-label": `${to}-button`, "data-testid": `${to}-button`, className: [className, triggerToClass()].join(" "), onClick: trigger, disabled: getTriggerState() }, children));
};
export const CarouselTrigger = styled(_CarouselTrigger) `
  cursor: pointer;
  user-select: none;

  &:disabled {
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=CarouselTrigger.js.map